import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export function LoadingSkeleton() {
  return (
    <div className="mb-8 md:mb-0">
      {/* filters */}
      <div className="flex justify-end flex-col flex-wrap items-end pt-8 md:pt-0 pb-4 md:pb-8">
        <div className="flex gap-2 flex-row flex-wrap items-center">
          <Skeleton width={109} height={38} />
          <Skeleton width={109} height={38} />
          <Skeleton width={225} height={38} />
        </div>
      </div>
      {/* Domain analytics */}
      <div className="bg-white rounded-lg p-4 md:p-7 mt-2 md:mt-0">
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-col flex-1">
            <Skeleton width="40%" height={32} />
            <Skeleton width="75%" height={28} className="mt-2" />
          </div>
          <div className="flex flex-col">
            <Skeleton width={80} height={24} />
            <span className="self-end">
              <Skeleton width={45} height={32} />
            </span>
          </div>
        </div>
        <hr className="h-px mt-4 mb-8 bg-gray-200 border-0" />
        <div className="grid md:grid-cols-3 gap-6 md:gap-10 w-full">
          <Skeleton height="120px" />
          <Skeleton height="120px" />
          <Skeleton height="120px" />
        </div>
      </div>
      {/* Most active profiles */}
      <div className="grid grid-cols-5 gap-4">
        <div className="bg-white rounded-lg p-4 md:p-7 mt-4 col-span-5 md:col-span-5">
          <div>
            <Skeleton width="50%" height={32} />
            <Skeleton width="70%" height={20} className="mt-2" />
            <hr className="h-px mt-4 mb-8 bg-gray-200 border-0 " />
          </div>
          <Skeleton height={340} />
        </div>
      </div>
      {/* top referrers and social links */}
      <div className="grid grid-cols-4 gap-4">
        <div className="bg-white rounded-lg p-4 md:p-7 mt-4 col-span-4 md:col-span-2">
          <Skeleton width="60%" height={32} />
          <Skeleton width="85%" height={28} />
          <hr className="h-px mt-4 mb-8 bg-gray-200 border-0" />
          <Skeleton height={340} />
        </div>
        <div className="bg-white rounded-lg p-4 md:p-7 mt-4 col-span-4 md:col-span-2">
          <Skeleton width="60%" height={32} />
          <Skeleton width="85%" height={28} />
          <hr className="h-px mt-4 mb-8 bg-gray-200 border-0" />
          <Skeleton height={340} />
        </div>
      </div>
      {/* top geolocation */}
      <div className="bg-white rounded-lg p-4 md:p-7 mt-4 flex col-span-12 md:col-span-12">
        <div className="w-full">
          <Skeleton width="45%" height={32} />
          <Skeleton width="85%" height={28} />
          <hr className="h-px my-4 bg-gray-200 border-0 " />
          <div className="mt-4">
            <div className="grid grid-cols-2 gap-2 w-full">
              <div className="col-span-2 md:col-span-1 self-center">
                <Skeleton height={300} />
              </div>
              <div className="col-span-2 mt-4 md:mt-0 md:col-span-1">
                <Skeleton height={300} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* profile analytics */}
      <div className="bg-white rounded-lg p-4 md:p-7 mt-4 flex flex-col col-span-12 md:col-span-12">
        <Skeleton width="45%" height={32} />
        <Skeleton width="85%" height={28} />
        <hr className="h-px mt-4 mb-8 bg-gray-200 border-0" />
        <Skeleton height={500} />
      </div>
    </div>
  );
}

export default LoadingSkeleton;
